export default {
  computed: {
    userProfiles() {
      return this.$store.state.authentication.userProfiles;
    },
  },
  methods: {
    isReadOnly() {
      return this.userProfiles && this.userProfiles.some(profile => profile.identification === 'Consulta');
    },
  },
};
